import React from "react";
export default function Community() {
  return (
    <section className="container mx-auto px-4 py-10 text-center">
      <h2 className="text-3xl font-bold text-green-700 mb-6">Our Community</h2>
      <p className="text-gray-700 max-w-2xl mx-auto">
        Proudly serving the vibrant community of Liberty City, Florida.
      </p>
    </section>
  );
}
